/* eslint-disable @typescript-eslint/no-non-null-asserted-optional-chain */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query';

import type { DealQuery, DetailedLandlordDeal } from './application.types';
import { getDetailedDocument } from './deals-dashboard.api';

const QUERY_KEY = 'detailedDeal';
const STALE_TIME = 30 * 60 * 1000; // 30 minutes - data stays "fresh" for 30 minutes

type DetailedDealQuery = DealQuery | null;

const createQueryOptions = (deal: DetailedDealQuery) =>
  queryOptions<DetailedLandlordDeal, Error>({
    queryKey: [QUERY_KEY, deal?.id, deal?.source],
    queryFn: () => getDetailedDocument(deal?.id!, deal?.source!),
    staleTime: STALE_TIME,
    refetchInterval: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });

export const useDetailedDeal = (deal: DetailedDealQuery) => {
  return useQuery<DetailedLandlordDeal, Error>({
    ...createQueryOptions(deal),
    enabled: Boolean(deal?.id && deal?.source),
  });
};

export const useDetailedDealSuspense = (deal: DetailedDealQuery) => {
  return useSuspenseQuery<DetailedLandlordDeal, Error>(createQueryOptions(deal));
};
